import { render } from "./AddOTPModel.vue?vue&type=template&id=5379e222&scoped=true"
import script from "./AddOTPModel.vue?vue&type=script&lang=js"
export * from "./AddOTPModel.vue?vue&type=script&lang=js"

import "./AddOTPModel.vue?vue&type=style&index=0&id=5379e222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5379e222"]])

export default __exports__